export type LEVEL_CONF = {
    "still": string;
    "talk": string;
    "grow": string;
    "inspire": string;
    "actForThePlanet": string;
    "superpowers": string;
    "borderRadius": number;
    "background": boolean;
    "background_color": string;
    "text_color": string;
}

export const getMenuConfiguration = (userLevel: "cycle1" | "cycle2" | "cycle3") => {
    // Gestion des images
    const imagesByLevelAndSection = {
        "cycle1": {
            "still": "illStillCycleOne",
            "talk": "illTalkCycleOne",
            "grow": "illGrowCycleOne",
            "inspire": "illInspireCycleOne",
            "actForThePlanet": "icPlanet",
            "superpowers": "illSuperPowersCycleOne",
            "borderRadius": 25,
            "background": true,
            "background_color": "#72EAFE",
            "text_color": "#354F84"
        },
        "cycle2": {
            "still": "illStillCycleTwo",
            "talk": "illTalkCycleTwo",
            "grow": "illGrowCycleTwo",
            "inspire": "illInspireCycleTwo",
            "actForThePlanet": "icPlanet",
            "superpowers": "illSuperPowersCycleTwo",
            "borderRadius": 25,
            "background": false,
            "background_color": "#72EAFE",
            "text_color": "#354F84"
        },
        "cycle3": {
            "still": "illStillCycleThree",
            "talk": "illTalkCycleThree",
            "grow": "illGrowCycleThree",
            "inspire": "illInspireCycleThree",
            "actForThePlanet": "icPlanet",
            "superpowers": "illSuperPowersCycleThree",
            "borderRadius": 6,
            "background": false,
            "background_color": "#354F84",
            "text_color": "#FFFFFF"
        }
    }

    return imagesByLevelAndSection[userLevel];
}